import L, { Control } from "leaflet";
import "leaflet/dist/leaflet.css";
import { FC, useEffect, useState } from "react";
import { createControlComponent } from "@react-leaflet/core";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import SkeletonComponent from "../../../shared/custom-spinner/skeleton.component";
import "leaflet/dist/leaflet.css";

const iconPerson = new L.Icon({
  iconUrl: require("../../../assets/images/marker.png"),
  iconRetinaUrl: require("../../../assets/images/marker.png"),
  iconSize: new L.Point(30, 30),
  className: "leaflet-div-icon",
});

export { iconPerson };

interface MapDetailProps {
  blockDetail: any;
  isLoadingBlockDetails: boolean;
}

const redMarker = new L.Icon({
  iconUrl: require("../../../assets/images/new-dashboard-icons/faultGreater20.png"),
  iconSize: new L.Point(55, 60),
  className: "leaflet-div-icon",
});

const greenMarker = new L.Icon({
  iconUrl: require("../../../assets/images//new-dashboard-icons/lightingOk.png"),
  iconSize: new L.Point(48, 52),
  className: "",
});

const yellowMarker = new L.Icon({
  iconUrl: require("../../../assets/images/new-dashboard-icons/faultLess20.png"),
  iconSize: new L.Point(48, 52),
  className: "",
});

export const ZoomControl = createControlComponent(
  (props) => new Control.Zoom(props)
);

const MapDetail: FC<MapDetailProps> = ({
  blockDetail,
  isLoadingBlockDetails,
}) => {
  const [zoom, setZoom] = useState(20);
  const [markers, setMarkers] = useState([] as any);
  const [center, setCenter] = useState([] as any);
  const [dataLoaded, setDataloaded] = useState(false);

  useEffect(() => {
    if (!blockDetail?.latitude && !blockDetail?.longitude) return;

    setCenter([blockDetail?.latitude, blockDetail?.longitude]);
    setMarkers([blockDetail]);
  }, [blockDetail]);

  useEffect(() => {
    if (!markers.length && !center.length) return;
    setDataloaded(true);
  }, [markers, center]);

  return (
    <div>
      <SkeletonComponent
        wrapperHeight={"584px"}
        skeletonHeight="584px"
        isLoading={!dataLoaded || isLoadingBlockDetails}
      >
        <MapContainer
          style={{ height: "362px", width: "100wh", borderRadius: "6px" }} // height: "365px"
          attributionControl={false}
          center={center as any}
          zoom={zoom}
          scrollWheelZoom={true}
          zoomControl={false}
          minZoom={12}
          maxZoom={18}
          maxBounds={[
            [1.21092, 103.60565],
            [1.47046, 104.04192],
          ]}
        >
          <ZoomControl position="topright" />

          <TileLayer
            maxZoom={20}
            maxNativeZoom={19}
            detectRetina={true}
            attribution='<img src="https://www.onemap.gov.sg/web-assets/images/logo/om_logo.png" style="height:20px;width:20px;"/>&nbsp;<a href="https://www.onemap.gov.sg/" target="_blank" rel="noopener noreferrer">OneMap</a>&nbsp;&copy;&nbsp;contributors&nbsp;&#124;&nbsp;<a href="https://www.sla.gov.sg/" target="_blank" rel="noopener noreferrer">Singapore Land Authority</a>'
            url="https://www.onemap.gov.sg/maps/tiles/Default_HD/{z}/{x}/{y}.png"
          />
          {markers.map((marker: any) => (
            <Marker
              key={marker.blockCode}
              icon={
                blockDetail?.status === "Green"
                  ? greenMarker
                  : blockDetail?.status === "Amber"
                    ? yellowMarker
                    : redMarker
              }
              position={[marker.latitude, marker.longitude]}
              eventHandlers={{
                mouseover: (e) => {
                  if (e.target && e.target.getPopup()) {
                    e.target.openPopup();
                  }
                },
                mouseout: (e) => {
                  if (e.target && e.target.getPopup()) {
                    e.target.closePopup();
                  }
                },
              }}
            >
              <Popup
                closeButton={false}
                position={[marker?.latitude, marker?.longitude]}
              >
                <div>
                  {marker.blockName}, {marker.street}, {marker.blockCode}
                </div>

                <div>Site: {marker.siteName}</div>
                <div>Supplier: {marker.slsSupplier}</div>

                {/* Block Code: {marker.blockCode}
                <br />
                Block Name: {marker.blockName} */}
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </SkeletonComponent>
    </div>
  );
};

export default MapDetail;
